
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta } from "/build/pages/index.vue?macro=true";
import { default as _91id_93TE_457MmM3r_GHndB6zL9LuBILPPArsIQs6KzEDqt9PigMeta } from "/build/pages/s/[id].vue?macro=true";
import { default as facebookQz2UPVltbOPiZ3RINP21ZMP30SfiEmBeV2_TBL_82QAMeta } from "/build/pages/callback/facebook.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/pages/index.vue")
  },
  {
    name: "s-id",
    path: "/s/:id()",
    component: () => import("/build/pages/s/[id].vue")
  },
  {
    name: "callback-facebook",
    path: "/callback/facebook",
    component: () => import("/build/pages/callback/facebook.vue")
  }
]